import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grain">
      <Nav />
      <div className="max-w-xl mx-auto px-5 sm:px-8 py-24 text-center">
        <XCircle className="w-12 h-12 text-[#8C3A34] mx-auto mb-6" />
        <h1 className="font-serif-display text-4xl text-[#F7F3EC] mb-3">Payment cancelled.</h1>
        <p className="text-[#A8A095] mb-8 font-serif-body">No charge was made. The manuscript remains sealed.</p>
        <Link to="/browse" className="btn-buy px-6 py-3 rounded-sm font-mono-brass text-xs uppercase tracking-widest font-semibold" data-testid="cancel-back">
          Return to archive
        </Link>
      </div>
    </div>
  );
}
